export const countryCallingCodes = [
  { code: 'CZ', prefix: '+420', example: '123 456 789' },
  { code: 'SK', prefix: '+421', example: '123 456 789' },
  { code: 'UA', prefix: '+380', example: '501234567' },
  { code: 'PL', prefix: '+48', example: '512345678' },
  { code: 'DE', prefix: '+49', example: '15123456789' },
  { code: 'AT', prefix: '+43', example: '664123456' },
  { code: 'RO', prefix: '+40', example: '712034567' },
  { code: 'RU', prefix: '+7', example: '9123456789' },
  { code: 'HU', prefix: '+36', example: '201234567' },
  { code: 'AC', prefix: '+247', example: '40123' },
  { code: 'AD', prefix: '+376', example: '312345' },
  { code: 'AE', prefix: '+971', example: '501234567' },
  { code: 'AF', prefix: '+93', example: '701234567' },
  { code: 'AG', prefix: '+1', example: '(268) 4641234' },
  { code: 'AI', prefix: '+1', example: '(264) 2351234' },
  { code: 'AL', prefix: '+355', example: '672123456' },
  { code: 'AM', prefix: '+374', example: '77123456' },
  { code: 'AN', prefix: '+599', example: '1234567' },
  { code: 'AO', prefix: '+244', example: '923123456' },
  { code: 'AQ', prefix: '+672', example: '381234' },
  { code: 'AR', prefix: '+54', example: '91123456789' },
  { code: 'AS', prefix: '+1', example: '(684) 7331234' },
  { code: 'AU', prefix: '+61', example: '412345678' },
  { code: 'AW', prefix: '+297', example: '5601234' },
  { code: 'AZ', prefix: '+994', example: '401234567' },
  { code: 'BA', prefix: '+387', example: '61123456' },
  { code: 'BB', prefix: '+1', example: '(246) 2501234' },
  { code: 'BD', prefix: '+880', example: '1812345678' },
  { code: 'BE', prefix: '+32', example: '470123456' },
  { code: 'BF', prefix: '+226', example: '70123456' },
  { code: 'BG', prefix: '+359', example: '48123456' },
  { code: 'BH', prefix: '+973', example: '36001234' },
  { code: 'BI', prefix: '+257', example: '79561234' },
  { code: 'BJ', prefix: '+229', example: '90011234' },
  { code: 'BL', prefix: '+590', example: '690001234' },
  { code: 'BM', prefix: '+1', example: '(441) 3701234' },
  { code: 'BN', prefix: '+673', example: '7123456' },
  { code: 'BO', prefix: '+591', example: '71234567' },
  { code: 'BQ', prefix: '+599', example: '3181234' },
  { code: 'BR', prefix: '+55', example: '11961234567' },
  { code: 'BS', prefix: '+1', example: '(242) 3591234' },
  { code: 'BT', prefix: '+975', example: '17123456' },
  { code: 'BW', prefix: '+267', example: '71123456' },
  { code: 'BY', prefix: '+375', example: '294911911' },
  { code: 'BZ', prefix: '+501', example: '6221234' },
  { code: 'CA', prefix: '+1', example: '5062345678' },
  { code: 'CC', prefix: '+61', example: '412345678' },
  { code: 'CD', prefix: '+243', example: '991234567' },
  { code: 'CF', prefix: '+236', example: '70012345' },
  { code: 'CG', prefix: '+242', example: '061234567' },
  { code: 'CH', prefix: '+41', example: '781234567' },
  { code: 'CI', prefix: '+225', example: '0123456789' },
  { code: 'CK', prefix: '+682', example: '71234' },
  { code: 'CL', prefix: '+56', example: '221234567' },
  { code: 'CM', prefix: '+237', example: '671234567' },
  { code: 'CN', prefix: '+86', example: '13123456789' },
  { code: 'CO', prefix: '+57', example: '3211234567' },
  { code: 'CR', prefix: '+506', example: '83123456' },
  { code: 'CU', prefix: '+53', example: '51234567' },
  { code: 'CV', prefix: '+238', example: '9911234' },
  { code: 'CW', prefix: '+599', example: '95181234' },
  { code: 'CX', prefix: '+61', example: '412345678' },
  { code: 'CY', prefix: '+357', example: '96123456' },
  { code: 'DG', prefix: '+246', example: '1234567', flagKey: 'IO' },
  { code: 'DJ', prefix: '+253', example: '77831001' },
  { code: 'DK', prefix: '+45', example: '32123456' },
  { code: 'DM', prefix: '+1', example: '(767) 2251234' },
  { code: 'DO', prefix: '+1', example: '(809) 2345678, (829) 2345678, (849) 2345678' },
  { code: 'DZ', prefix: '+213', example: '551234567' },
  { code: 'EC', prefix: '+593', example: '991234567' },
  { code: 'EE', prefix: '+372', example: '51234567' },
  { code: 'EG', prefix: '+20', example: '1001234567' },
  { code: 'EH', prefix: '+212', example: '650123456' },
  { code: 'ER', prefix: '+291', example: '7123456' },
  { code: 'ES', prefix: '+34', example: '612345678' },
  { code: 'ET', prefix: '+251', example: '911234567' },
  { code: 'FI', prefix: '+358', example: '412345678' },
  { code: 'FJ', prefix: '+679', example: '7012345' },
  { code: 'FK', prefix: '+500', example: '51234' },
  { code: 'FM', prefix: '+691', example: '3501234' },
  { code: 'FO', prefix: '+298', example: '211234' },
  { code: 'FR', prefix: '+33', example: '612345678' },
  { code: 'GA', prefix: '+241', example: '06031234' },
  { code: 'GB', prefix: '+44', example: '7400123456' },
  { code: 'GD', prefix: '+1', example: '(473) 4031234' },
  { code: 'GE', prefix: '+995', example: '555123456' },
  { code: 'GF', prefix: '+594', example: '694201234' },
  { code: 'GG', prefix: '+44', example: '(1481) 123456' },
  { code: 'GH', prefix: '+233', example: '231234567' },
  { code: 'GI', prefix: '+350', example: '57123456' },
  { code: 'GL', prefix: '+299', example: '221234' },
  { code: 'GM', prefix: '+220', example: '3012345' },
  { code: 'GN', prefix: '+224', example: '601123456' },
  { code: 'GP', prefix: '+590', example: '690001234' },
  { code: 'GQ', prefix: '+240', example: '222123456' },
  { code: 'GR', prefix: '+30', example: '6912345678' },
  { code: 'GT', prefix: '+502', example: '51234567' },
  { code: 'GU', prefix: '+1', example: '(671) 3001234' },
  { code: 'GW', prefix: '+245', example: '955012345' },
  { code: 'GY', prefix: '+592', example: '6091234' },
  { code: 'HK', prefix: '+852', example: '51234567' },
  { code: 'HN', prefix: '+504', example: '91234567' },
  { code: 'HR', prefix: '+385', example: '921234567' },
  { code: 'HT', prefix: '+509', example: '34101234' },
  { code: 'ID', prefix: '+62', example: '812345678' },
  { code: 'IE', prefix: '+353', example: '850123456' },
  { code: 'IL', prefix: '+972', example: '502345678' },
  { code: 'IM', prefix: '+44', example: '(1624) 123456' },
  { code: 'IN', prefix: '+91', example: '8123456789' },
  { code: 'IO', prefix: '+246', example: '3801234' },
  { code: 'IQ', prefix: '+964', example: '7912345678' },
  { code: 'IR', prefix: '+98', example: '9123456789' },
  { code: 'IS', prefix: '+354', example: '6111234' },
  { code: 'IT', prefix: '+39', example: '3123456789' },
  { code: 'JE', prefix: '+44', example: '(1534) 123456' },
  { code: 'JM', prefix: '+1', example: '(658) 2101234, (876) 2101234' },
  { code: 'JO', prefix: '+962', example: '790123456' },
  { code: 'JP', prefix: '+81', example: '9012345678' },
  { code: 'KE', prefix: '+254', example: '712123456' },
  { code: 'KG', prefix: '+996', example: '700123456' },
  { code: 'KH', prefix: '+855', example: '91234567' },
  { code: 'KI', prefix: '+686', example: '72001234' },
  { code: 'KM', prefix: '+269', example: '3212345' },
  { code: 'KN', prefix: '+1', example: '(869) 7652917' },
  { code: 'KP', prefix: '+850', example: '1921234567' },
  { code: 'KR', prefix: '+82', example: '1020000000' },
  { code: 'KW', prefix: '+965', example: '50012345' },
  { code: 'KY', prefix: '+1', example: '(345) 3231234' },
  { code: 'KZ', prefix: '+7', example: '7710009998' },
  { code: 'LA', prefix: '+856', example: '2023123456' },
  { code: 'LB', prefix: '+961', example: '71123456' },
  { code: 'LC', prefix: '+1', example: '(758) 2845678' },
  { code: 'LI', prefix: '+423', example: '660234567' },
  { code: 'LK', prefix: '+94', example: '712345678' },
  { code: 'LR', prefix: '+231', example: '770123456' },
  { code: 'LS', prefix: '+266', example: '50123456' },
  { code: 'LT', prefix: '+370', example: '61234567' },
  { code: 'LU', prefix: '+352', example: '628123456' },
  { code: 'LV', prefix: '+371', example: '21234567' },
  { code: 'LY', prefix: '+218', example: '912345678' },
  { code: 'MA', prefix: '+212', example: '650123456' },
  { code: 'MC', prefix: '+377', example: '612345678' },
  { code: 'MD', prefix: '+373', example: '62112345' },
  { code: 'ME', prefix: '+382', example: '67622901' },
  { code: 'MF', prefix: '+590', example: '690001234' },
  { code: 'MG', prefix: '+261', example: '321234567' },
  { code: 'MH', prefix: '+692', example: '2351234' },
  { code: 'MK', prefix: '+389', example: '72345678' },
  { code: 'ML', prefix: '+223', example: '65012345' },
  { code: 'MM', prefix: '+95', example: '92123456' },
  { code: 'MN', prefix: '+976', example: '88123456' },
  { code: 'MO', prefix: '+853', example: '66123456' },
  { code: 'MP', prefix: '+1', example: '(670) 2345678' },
  { code: 'MQ', prefix: '+596', example: '696201234' },
  { code: 'MR', prefix: '+222', example: '22123456' },
  { code: 'MS', prefix: '+1', example: '(664) 4923456' },
  { code: 'MT', prefix: '+356', example: '96961234' },
  { code: 'MU', prefix: '+230', example: '52512345' },
  { code: 'MV', prefix: '+960', example: '7712345' },
  { code: 'MW', prefix: '+265', example: '991234567' },
  { code: 'MX', prefix: '+52', example: '12221234567' },
  { code: 'MY', prefix: '+60', example: '123456789' },
  { code: 'MZ', prefix: '+258', example: '821234567' },
  { code: 'NA', prefix: '+264', example: '811234567' },
  { code: 'NC', prefix: '+687', example: '751234' },
  { code: 'NE', prefix: '+227', example: '93123456' },
  { code: 'NF', prefix: '+672', example: '381234' },
  { code: 'NG', prefix: '+234', example: '8021234567' },
  { code: 'NI', prefix: '+505', example: '81234567' },
  { code: 'NL', prefix: '+31', example: '612345678' },
  { code: 'NO', prefix: '+47', example: '40612345' },
  { code: 'NP', prefix: '+977', example: '9841234567' },
  { code: 'NR', prefix: '+674', example: '5551234' },
  { code: 'NU', prefix: '+683', example: '8884012' },
  { code: 'NZ', prefix: '+64', example: '211234567' },
  { code: 'OM', prefix: '+968', example: '92123456' },
  { code: 'PA', prefix: '+507', example: '61234567' },
  { code: 'PE', prefix: '+51', example: '912345678' },
  { code: 'PF', prefix: '+689', example: '87123456' },
  { code: 'PG', prefix: '+675', example: '70123456' },
  { code: 'PH', prefix: '+63', example: '9051234567' },
  { code: 'PK', prefix: '+92', example: '3012345678' },
  { code: 'PM', prefix: '+508', example: '551234' },
  { code: 'PR', prefix: '+1', example: '(787) 2345678, (939) 2345678' },
  { code: 'PS', prefix: '+970', example: '599123456' },
  { code: 'PT', prefix: '+351', example: '912345678' },
  { code: 'PW', prefix: '+680', example: '6201234' },
  { code: 'PY', prefix: '+595', example: '961456789' },
  { code: 'QA', prefix: '+974', example: '33123456' },
  { code: 'RE', prefix: '+262', example: '692123456' },
  { code: 'RS', prefix: '+381', example: '601234567' },
  { code: 'RW', prefix: '+250', example: '720123456' },
  { code: 'SA', prefix: '+966', example: '512345678' },
  { code: 'SB', prefix: '+677', example: '7421234' },
  { code: 'SC', prefix: '+248', example: '2510123' },
  { code: 'SD', prefix: '+249', example: '911231234' },
  { code: 'SE', prefix: '+46', example: '701234567' },
  { code: 'SG', prefix: '+65', example: '81234567' },
  { code: 'SH', prefix: '+290', example: '51234' },
  { code: 'SI', prefix: '+386', example: '31234567' },
  { code: 'SJ', prefix: '+47', example: '41234567' },
  { code: 'SL', prefix: '+232', example: '25123456' },
  { code: 'SM', prefix: '+378', example: '66661212' },
  { code: 'SN', prefix: '+221', example: '701234567' },
  { code: 'SO', prefix: '+252', example: '71123456' },
  { code: 'SR', prefix: '+597', example: '7412345' },
  { code: 'SS', prefix: '+211', example: '977123456' },
  { code: 'ST', prefix: '+239', example: '9812345' },
  { code: 'SV', prefix: '+503', example: '70123456' },
  { code: 'SX', prefix: '+1', example: '(721) 5205678' },
  { code: 'SY', prefix: '+963', example: '944567890' },
  { code: 'SZ', prefix: '+268', example: '76123456' },
  { code: 'TA', prefix: '+290', example: '(8) 999' },
  { code: 'TC', prefix: '+1', example: '(649) 2311234' },
  { code: 'TD', prefix: '+235', example: '63012345' },
  { code: 'TG', prefix: '+228', example: '90112345' },
  { code: 'TH', prefix: '+66', example: '812345678' },
  { code: 'TJ', prefix: '+992', example: '917123456' },
  { code: 'TK', prefix: '+690', example: '7290' },
  { code: 'TL', prefix: '+670', example: '77212345' },
  { code: 'TM', prefix: '+993', example: '66123456' },
  { code: 'TN', prefix: '+216', example: '20123456' },
  { code: 'TO', prefix: '+676', example: '7715123' },
  { code: 'TR', prefix: '+90', example: '5012345678' },
  { code: 'TT', prefix: '+1', example: '(868) 2911234' },
  { code: 'TV', prefix: '+688', example: '901234' },
  { code: 'TW', prefix: '+886', example: '912345678' },
  { code: 'TZ', prefix: '+255', example: '621234567' },
  { code: 'UG', prefix: '+256', example: '712345678' },
  { code: 'US', prefix: '+1', example: '2015550123' },
  { code: 'UY', prefix: '+598', example: '94231234' },
  { code: 'UZ', prefix: '+998', example: '912345678' },
  { code: 'VA', prefix: '+39', example: '3123456789' },
  { code: 'VC', prefix: '+1', example: '(784) 4301234' },
  { code: 'VE', prefix: '+58', example: '4121234567' },
  { code: 'VG', prefix: '+1', example: '(284) 3001234' },
  { code: 'VI', prefix: '+1', example: '(340) 6421234' },
  { code: 'VN', prefix: '+84', example: '912345678' },
  { code: 'VU', prefix: '+678', example: '5912345' },
  { code: 'WF', prefix: '+681', example: '821234' },
  { code: 'WS', prefix: '+685', example: '7212345' },
  { code: 'XK', prefix: '+383', example: '43201234' },
  { code: 'YE', prefix: '+967', example: '712345678' },
  { code: 'YT', prefix: '+262', example: '639012345' },
  { code: 'ZA', prefix: '+27', example: '711234567' },
  { code: 'ZM', prefix: '+260', example: '955123456' },
  { code: 'ZW', prefix: '+263', example: '712345678' }
];
